import React, { useContext } from "react";
import { Toolbar, Box } from "@mui/material";
import SideMenuBar from "./SideMenuBar";
import { AppBarHeader } from "./header/AppBarHeader";
import { Outlet } from "react-router-dom"; // Import Outlet
import { UserContext } from "../context/UserProvider";

function MainDash() {
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBarHeader open={open} handleDrawerOpen={handleDrawerOpen} />
      <SideMenuBar open={open} setOpen={setOpen} />

      <Box
        component="main"
        position={"fixed"}
        width={"100%"}
        height={"100vh"}
        pl={10}
        pr={3}
        pt={3}
        pb={3}
        sx={{
          overflowY: "auto",
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}

export default MainDash;
